import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';
import { isConfiguredApiUrl, isLoginUrl } from '@core/config/api.config';
import { AuthService } from '@core/auth/auth.service';
import { TokenStorageService } from '@core/services/token-storage.service';

let redirectingToLogin = false;

export const authInterceptor: HttpInterceptorFn = (request, next) => {
  const tokenStorage = inject(TokenStorageService);
  const authService = inject(AuthService);
  const router = inject(Router);

  const shouldAttachToken =
    isConfiguredApiUrl(request.url) &&
    !isLoginUrl(request.url) &&
    !request.headers.has('Authorization') &&
    Boolean(tokenStorage.getToken());

  const authRequest = shouldAttachToken
    ? request.clone({
        setHeaders: {
          Authorization: `Bearer ${tokenStorage.getToken()}`,
        },
      })
    : request;

  return next(authRequest).pipe(
    catchError((error: unknown) => {
      if (
        error instanceof HttpErrorResponse &&
        error.status === 401 &&
        isConfiguredApiUrl(request.url) &&
        !isLoginUrl(request.url)
      ) {
        authService.endSessionAfterUnauthorized();

        if (!redirectingToLogin) {
          redirectingToLogin = true;
          void router.navigate(['/login']).finally(() => {
            redirectingToLogin = false;
          });
        }
      }

      return throwError(() => error);
    }),
  );
};
